import { z } from "zod";

/**
 * File upload schema shape
 */
export const fileSchema = z.object({
  file: z.string(),
  name: z.string(),
  size: z.number(),
  type: z.string(),
  original: z.any(),
  altText: z.string().optional(),
});

/**
 * Optional file upload field (photo, avatar, etc.)
 */
export const optionalFileField = z.preprocess(
  (val) => (val == null ? undefined : val),
  fileSchema.optional()
);

/**
 * Photo upload field
 */
export const photoField = optionalFileField;

/**
 * CV/Resume upload field
 */
export const cvField = optionalFileField;

